import { render } from "./SubcategoryManager.vue?vue&type=template&id=1a0aee45"
import script from "./SubcategoryManager.vue?vue&type=script&lang=js"
export * from "./SubcategoryManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__